import { CTAButton } from "./CTAButton";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./BrandIcons";
import { waLink } from "@/lib/site";
import { goToContact } from "@/lib/scroll";

export const Conversion = () => (
  <section data-testid="conversion-section" className="relative overflow-hidden border-y border-white/5 py-28 sm:py-40">
    <div className="line-grid mask-radial pointer-events-none absolute inset-0" />
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-ws-lime/[0.12] blur-[140px]" />
    <img src="/img/emblem.webp" alt="" aria-hidden="true" className="logo-blend float-y-slow pointer-events-none absolute left-1/2 top-1/2 w-[520px] -translate-x-1/2 -translate-y-1/2 opacity-20 sm:w-[760px]" />
    <Reveal className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <h2 data-testid="conversion-title" className="font-display text-4xl font-semibold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
        Pronto para levar seu negócio para o <span className="text-ws-lime text-glow">digital?</span>
      </h2>
      <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-ws-muted md:text-lg">
        Conte para a WebStation o que você precisa e vamos encontrar a melhor solução para o seu projeto.
      </p>
      <div className="mt-11 flex flex-col justify-center gap-3 sm:flex-row">
        <CTAButton testid="conversion-cta-quote" onClick={() => goToContact()}>Solicitar orçamento</CTAButton>
        <CTAButton testid="conversion-cta-whatsapp" variant="ghost" href={waLink()} icon={false}>
          <span className="flex items-center gap-2"><WhatsAppIcon size={18} className="text-[#25D366]" /> Falar pelo WhatsApp</span>
        </CTAButton>
      </div>
    </Reveal>
  </section>
);
